// extracted by mini-css-extract-plugin
module.exports = {"Paper":"PopupDialog_Paper__3uuOX","DialogContent":"PopupDialog_DialogContent__1bZZh","DialogBackground":"PopupDialog_DialogBackground__RQBg7"};